var utils = require('../../utils')

export default {
  name: 'careman-edit',
  data: function () {
    return {
      shopId: '',
      careOfficeId: '',
      careOfficeName: '',
      acCareOfficeName: '',
      caremanName: '',
      caremanFurigana: '',
      caremanTel: '',
      caremanMail: '',
      isNewCareman: false,
      utils: utils,
      changeDate: '',
      searchCallbackFlag: false // 検索結果フラグ
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.autocompleteEventRemove({$: $, elem:'#careoffice_name_autocomplete'}) // オートコンプリートイベント削除
    next()
  },
  created: function () {
    // this.$store.dispatch('SHOP_SEARCH')
    this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})

    if (this.$store.getters.canManage) {
      this.shopId = this.$store.getters.currentShopId
    }
    this.isNewCareman = utils.isBlank(this.$route.params.caremanHisId)
    this.clearSearch()
    if (!this.isNewCareman) {
      // 編集
      this.search()
    } else {
      // 新規作成
      if (utils.isPresent(this.$route.params.careOfficeId)) {
        // 介護支援事業所指定
        var self = this
        var callback = function () {
          if (self.careoffice !== null && self.careoffice.length > 0) {
            self.careOfficeId = self.careoffice[0].id
            self.careOfficeName = self.careoffice[0].attributes['careoffice-name']
            self.acCareOfficeName = self.careoffice[0].attributes['careoffice-name']
          }
          self.searchCallbackFlag = true
        }
        this.$store.dispatch('CARE_OFFICE_SEARCH', {
          data: {careoffice_id: this.$route.params.careOfficeId},
          loadparams:       true,
          autocomplete:     false,
          callback:         callback
        })
      } else {
        this.searchCallbackFlag = true
      }
    }

    // オートコンプリートイベント
    utils.autocompleteEvent({
      $:                  $,
      elem:               '#careoffice_name_autocomplete',
      search:             () => {},
      searchParams:       false,
      searchAutocomplete: this.getCareOffices,
      setSearchData:      this.setSearchCareOffice,
      clear:              this.clearCareOffices,
    })
  },
  mounted () {
    if (!this.isNewCareman) {
      // ヘルプボタン表示
      utils.helpModalShow()
    }
  },
  computed: {
    careman() {
      return this.$store.getters.careman
    },
    careoffice() {
      return this.$store.getters.careOffices
    },
    careOffices() {
      return this.$store.getters.careOfficesAutocomplete
    },
    /** 必須チェック */
    required: function() {
      return {
        careOfficeId:           utils.isBlank(this.careOfficeId),          // 介護支援事業所
        caremanName:            utils.isBlank(this.caremanName),           // ケアマネジャー
        caremanFurigana_format: !utils.isHiragana(this.caremanFurigana),   // ひらがな
        caremanTel_format:      !utils.isPhone(this.caremanTel),           // 電話番号
        caremanMail_format:     !utils.isEmail(this.caremanMail),          // メール
        changeDate_format:      !utils.isWareki(this.$t, this.changeDate), // 日付
      }
    },
    /** 必須チェック全てOK */
    isRequiredComplete () {
      var req  = this.required
      var result = true
      // 必須
      for (var key in req) {
        if (req[key]) {
          result = false
          break
        }
      }
      return result
    },
    loading() {
      return this.$store.getters.apiLoading
    },
    notify() {
      return this.$store.getters.caremanNotify
    }
  },
  methods: {
    search: function () {
      var data = {
        careman_history_id: this.$route.params.caremanHisId
      }
      var self = this
      var callback = function () {
        if (utils.isBlank(self.careman)) {
          self.goPrev()
          return
        }
        self.careOfficeId     = self.careman.attributes['careoffice-id']
        self.careOfficeName   = self.careman.attributes['careoffice-name']
        self.acCareOfficeName = self.careman.attributes['careoffice-name']
        self.caremanName      = self.careman.attributes['careman-name']
        self.caremanFurigana  = self.careman.attributes['careman-name-furigana']
        self.caremanTel       = self.careman.attributes['mobile']
        self.caremanMail      = self.careman.attributes['email']
        self.changeDate       = ''
        self.searchCallbackFlag = true
      }
      this.searchCallbackFlag = false
      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR', 0)
      this.$store.dispatch('CAREMAN_SEARCH_HISTORY', { data: data, callback: callback })
    },
    goFacilities: function () {
      this.$router.push({ path: '/facilities', query:{type: this.$router.currentRoute.query.type} })
    },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query:{type: this.$router.currentRoute.query.type} })
    },
    goClinics: function () {
      this.$router.push({ path: '/clinics', query:{type: this.$router.currentRoute.query.type} })
    },
    goDoctors: function () {
      this.$router.push({ path: '/doctors', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareOffices: function () {
      this.$router.push({ path: '/care_offices', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareManagers: function () {
      this.$router.push({ path: '/care_managers', query:{type: this.$router.currentRoute.query.type} })
    },
    goCaremanList: function () {
      if (utils.isBlank(this.$route.params.careOfficeId)) {
        this.$router.push({ path: '/care_managers', query:{type: this.$router.currentRoute.query.type, keep: 'true'} })
      } else {
        // 介護支援事業所指定
        this.$router.push({ path: '/care_managers/list/' + this.$route.params.careOfficeId, query:{type: this.$router.currentRoute.query.type, keep: 'true'} })
      }
    },
    goPrev: function () {
      if (this.isNewCareman) {
        this.goCaremanList()
      } else {
        if (utils.isBlank(this.$route.params.careOfficeId)) {
          this.$router.push({ path: '/care_managers/' + this.$route.params.caremanId, query:{type: this.$router.currentRoute.query.type} })
        } else {
          // 介護支援事業所指定
          this.$router.push({ path: '/care_managers/' + this.$route.params.caremanId + '/' + this.$route.params.careOfficeId, query:{type: this.$router.currentRoute.query.type} })
        }
      }
    },
    onClickSave: function () {
      if (!this.isRequiredComplete) {
        return
      }
      if (utils.isBlank(this.caremanTel)) {
        this.save()
        return
      }
      this.$store.dispatch('CAREMAN_DUPLICATE_CHECK', {
        data: {
          careman_id: this.$route.params.caremanId,
          mobile: this.caremanTel
        },
        callback: (result) => {
          if (result) {
            var button = document.getElementById('duplicate_tel_modal_button')
            button.click()
          } else {
            this.save()
          }
        }
      })
    },
    save: function(){
      var caremanId = null
      if (utils.isPresent(this.$route.params.caremanId)) {
        caremanId = this.$route.params.caremanId
      }
      var data = {
        careman_history_id:    this.$route.params.caremanHisId,
        careman_id:            caremanId,
        careoffice_id:         this.careOfficeId,
        careman_name:          this.caremanName,
        careman_name_furigana: this.caremanFurigana,
        mobile:                this.caremanTel,
        email:                 this.caremanMail,
        change_date:           this.isNewCareman ? "" : utils.wareki2Seireki(this.$t, this.changeDate, 'y-m-d')
      }
      var self = this
      var callback = function () {
        self.goPrev()
      }
      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR', 0)
      this.$store.dispatch('CAREMAN_EDIT', {data: data, callback: callback})
    },

    /** 介護事業所 */
    getCareOffices: function () {
      var clear        = false
      var autocomplete = true
      var send_fails   = 0

      var data = {
        'shop_id':          this.shopId,
        'careoffice_name':  this.acCareOfficeName,
        'send_fails':       send_fails,
        'all_get':          true,
      }
      this.$store.dispatch('CARE_OFFICE_SEARCH', { clear: clear, data: data, autocomplete: autocomplete, loadparams: false})
    },
    clearCareOffices: function () {
      if (this.acCareOfficeName !== this.careOfficeName) {
        this.acCareOfficeName = this.careOfficeName
        this.$store.dispatch('CAREMAN_MSG_ALERT', { message_i18n: 'messages.select_list_item', danger: true })
      }
      // オートコンプリートクリア
      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR')
    },
    setSearchCareOffice: function (id, name) {
      this.careOfficeId = id
      this.careOfficeName = name
      this.acCareOfficeName = name
      // オートコンプリートクリア
      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR')
    },
    getReferenceDate: function () {
      if (this.careman !== null) {
        var start = this.utils.sereki2Wareki(this.$t, new Date(this.careman.attributes['start-date']))
        var end = new Date(this.careman.attributes['end-date'])
        if (end.getFullYear() == this.$t('history.max_year')) {
          end = this.$t('history.max_display')
        } else {
          end = this.utils.sereki2Wareki(this.$t, end)
        }
        return start + this.$t('history.delimiter') + end
      } else {
        return ''
      }
    },
    clearSearch: function () {
      this.$store.dispatch('CAREMAN_EDIT_CLEAR')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/careman-edit.js